export var VERSION = "1.3.12";
//# sourceMappingURL=version.js.map